var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',[_vm._v(_vm._s(_vm.MAIL))]),_c('vs-divider',{staticStyle:{"margin":"0px !important"}}),_vm._v("\n  Kay: "+_vm._s(_vm.GUIDKOD)+"\n  "),_c('vs-divider',{staticStyle:{"margin":"0px !important"}}),_vm._v(" Onay Zamanı:\n  "),_c('span',{staticStyle:{"color":"#ea5455"}},[_vm._v(_vm._s(_vm.ONAYZAMAN))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }